import React, { Component } from 'react';
import EfficientMoveCycle from '../../ui_core/EfficientMoveCycle';
import ParameterErrors from '../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
export default class SliderHandle extends Component{
    constructor(props) {
        super(props);
        const { callbackMoved } = props;
        if (!callbackMoved) throwNotProvided("callbackMoved");
        this._callbackMoved = callbackMoved;
        this.setPosition = this.setPosition.bind(this);
        this._handleDragStart = this._handleDragStart.bind(this);
        this._handleDragMove = this._handleDragMove.bind(this);
        this._handleDragEnd = this._handleDragEnd.bind(this);
        this._element = React.createRef();
        this._startPosition = null;
        this._mouseStartPosition = null;
        this.state = {
            position: { x: 0, y: 0 },
            capturing: false
        };
    }
	get element(){
		return this._element.current;
	}
    setPosition(position) {
        this.setState({ position: position });
    }
    get startPosition() {
        return this._startPosition;
    }
    _handleDragStart(e, isTouch) {
		if(isTouch)
			e=e.touches[0];
        const element = this._element.current;
        this._startPosition = { x: element.offsetLeft+(element.offsetWidth/2), y: element.offsetTop+(element.offsetHeight/2) };
        this._mouseStartPosition = { x: e.clientX, y: e.clientY };
        this.setState({ capturing: true });
    }
    _handleDragMove(e, isTouch) {
		if(isTouch)
			e=e.touches[0];
        const dX = e.clientX - this._mouseStartPosition.x;
        const dY = e.clientY - this._mouseStartPosition.y;
        this._callbackMoved(dX, dY);
    }
    _handleDragEnd(e) {
        this.setState({ capturing: false });
    }
    render() {
        const position = this.state.position;
        const className = "handle" + (this.state.capturing ? " active" : "");
        return (<div className={className} ref={this._element} onMouseDown={this._handleMouseDown}
            onMouseUp={this._handleMouseUp} onMouseLeave={this._handlemouseLeave}
            style={{ top: position.y, left:position.x}}></div>);
    }
    componentDidMount() {
        this._efficientMoveCycle = new EfficientMoveCycle({
            element: this._element.current,
            onStart: this._handleDragStart,
            onMove: this._handleDragMove,
            onEnd:this._handleDragEnd,
			stopPropagation:true,
			preventDefault:true
        });
    }
}